module.exports = __webpack_public_path__ + "static/doctors6.8dc9647c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/doctors6.png
// module id = ./src/media/doctors6.png
// module chunks = 2345137460201621000